export const LOGIN = {
  PAGE: {
    welcome: 0,
    registration: 1
  },
}
